module.exports = __webpack_public_path__ + "static/media/grid-selected.1b98a003.svg";